<template>
  <div class="footer">
    <div class="contain">
      <div class="three wow fadeInUp clearfix">
        <div class="whiteLogo fl">
          <img src="./img/Image_Acorn_Logo.png" srcset="./img/Image_Acorn_Logo.png 2x">
        </div>
        <div class="whiteLogoMobil fl">
          <img src="./img/mobile_footer_logo.png" srcset="./img/mobile_footer_logo@2x.png 2x">
        </div>
        <div class="w100 fr">
          <div class="linkList fl">
            <ul>
              <li>{{$t('footer_links')}}</li>
              <li><a href="https://maro.eco/#/">Maro</a></li>
            </ul>
          </div>
          <div class="linkList fl">
            <ul>
              <li>{{$t('footer_resources')}}</li>
              <li><a href="https://acornbox.org" target="_blank">Acorn Box</a></li>
              <li><a href="https://connect.ma.ro" target="_blank">MARO Connect</a></li>
            </ul>
          </div>
          <div class="media fl">
            <div class="tit">{{$t('footer_media')}}</div>
            <ul class="clearfix">
              <li v-for="(item, index) in iconList" :key="index">
                <a v-if="item.type === 'qr'" @mouseenter="item.show = true" @mouseleave="item.show = false">
                 <img v-show='item.show' class="qrcode qrWehat" :src="item.hoverIcon">
                 <img  :src="item.icon" >
               </a>
               <a v-else-if="item.type === 'talk'" :href="item.link" target="_blank" @mouseenter="item.show = true" @mouseleave="item.show = false">
                 <img v-show='item.show' class="qrcode" :src="item.hoverIcon">
                 <img  :src="item.icon">
               </a>
                <a v-else :href="item.link" target="_blank" @mouseenter="item.show = true" @mouseleave="item.show = false">
                  <img v-show="item.show" :src="item.hoverIcon" alt="">
                  <img v-show="!item.show" :src="item.icon" alt="">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="lineBox wow fadeInUp clearfix">
        <div class="copyRight fl wow fadeInUp">
          <a href="http://acorn.ttcnet.io/document?doc=walletagreement&lang=zh" target="_blank">Terms &amp; Conditions</a>
          <span>ㅣ</span>
          <a href="http://acorn.ttcnet.io/document?doc=walletprivacypolicy&lang=zh" target="_blank">Privacy Policy</a>
          <span class="rights">&nbsp;Copyright © 2023 TTC Foundation PTE. All rights reserved.</span>
        </div>
        <div class="logo fr">
          <img src="./img/Image_Acorn_Fonts.png" alt="./img/Image_Acorn_Fonts@2x.png 2x">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iconList: [
        {
          link: 'https://t.me/acorn_kr',
          class: 'icon-kr',
          icon: require('./img/kr.svg'),
          hoverIcon: require('./img/krH.svg')
        },
        {
          link: 'https://t.me/acorn_en',
          icon: require('./img/en.svg'),
          hoverIcon: require('./img/enH.svg')
        },
        {
          link: 'https://t.me/acorn_official',
          icon: require('./img/tg.svg'),
          hoverIcon: require('./img/tgH.svg')
        },
        {
          link: 'mailto:official@ttc.eco',
          icon: require('./img/mail.svg'),
          hoverIcon: require('./img/mailH.svg')
        },
        {
          link: 'https://bitcointalk.org/index.php?topic=5163692.msg51771876#msg51771876',
          icon: require('./img/bit.svg'),
          hoverIcon: require('./img/bitH.svg')
        },
        {
          link: 'https://twitter.com/AcornProtocol',
          icon: require('./img/Twitter.svg'),
          hoverIcon: require('./img/twH.svg')
        },
        {
          link: 'https://discord.gg/zK9apWJc',
          icon: require('./img/discord.svg'),
          hoverIcon: require('./img/discordH.svg')
        }
      ]
    }
  },
  methods: {

  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.footer{
  padding-bottom: 80px;
  background:#191919;
  .contain{
    padding-top: 80px;
    .three{
      .whiteLogo{
        display: block;
        width: 86px;
        img{
          width:100%;
        }
      }
      .whiteLogoMobil{
        display: none;
        width: 100%;
        margin-bottom: 40px;
        img{
          width: 122px;
        }
      }
      .w100{
        width: auto;
      }
      .media{
        .tit{
          font-size: 16px;
          font-family: GothamPro-Bold, GothamPro;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 19px;
          text-align: right;
          margin-bottom: 16px;
        }
        ul{
          max-width: 164px;
          li{
            float: right;
            width: 32px;
            height: 32px;
            margin-left: 12px;
            margin-bottom: 12px;
            &:nth-child(4){
              margin-left: 0;
            }
            &:nth-child(8){
              margin-left: 0;
            }
            a{
              display: inline-block;
              position: relative;
              img{
                width: 100%;
              }
              .qrcode {
                width: 80px;
                max-width: unset;
                position: absolute;
                top: -72px;
                left: -24px;
              }
              .qrWehat {
                width: 140px;
                max-width: unset;
                position: absolute;
                top: -130px;
                left: -55px;
              }
            }
          }
        }
      }
      .linkList{
        width: 300px;
        ul{
          li{
            margin-bottom: 16px;
            font-size: 16px;
            font-family: GothamPro-Bold, GothamPro;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 19px;
            a{
              font-weight: 400;
              text-decoration: none;
              font-family: GothamPro;
              color: #FFFFFF;
              line-height: 19px;
              &:hover{
                color: #1DBF77;
              }
            }
          }
        }
      }
    }
    .lineBox{
      padding-top: 92px;
      .copyRight{
        padding-top: 42px;
        a{
          font-size: 16px;
          font-family: GothamPro;
          color: #FFFFFF;
          line-height: 18px;
            &:hover{
                color: #1DBF77;
              }
        }
        span{
          font-size: 16px;
          font-family: GothamPro;
          color: #FFFFFF;
          line-height: 18px;
          &.rights{
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
      .logo{
        display: block;
        width: 146px;
      }
    }
  }
}
@media screen and (max-width:1439px){
  .footer{
    .contain{
      .three{
        .linkList{
          width: 200px;
        }
      }
    }
  }
}
@media screen and (max-width:1199px){
  .footer{
    .contain{
      .three{
        .linkList{
          width: 130px;
        }
      }
      .lineBox{
        .copyRight{
          padding-top: 24px;
          .rights{
            display: block;
          }
        }
      }
    }
  }
}
@media screen and (max-width:760px){
  .footer{
    .contain{
      padding-top: 50px;
      .three{
        .whiteLogo{
          width: 43px;
          margin-bottom: 40px;
        }
        .w100{
          width: 100%;
        }
        .linkList{
          margin-bottom: 30px;
          width: 50%;
          ul{
            li{
              margin-bottom: 10px;
              a{
                font-size: 16px;
                line-height: 19px;
              }
            }
          }
        }
        .media{
          width: 100%;
          .tit{
            font-size: 16px;
            line-height: 19px;
            margin-bottom: 13px;
            text-align: left;
          }
          ul{
            max-width: 190px;
            li{
              float: left;
              margin-left: 0;
              margin-right: 12px;
            }
          }
        }
      }
      .lineBox{
        padding-top: 10px;
        .logo{
          display: none;
        }
        .copyRight{
          a{
            font-size: 11px;
            line-height: 14px;
          }
          span{
            font-size: 11px;
            line-height: 14px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue